import React from 'react';
import Layout from '../components/layout/Layout';
import ChatInterface from '../components/chat/ChatInterface';
import { ChatProvider } from '../context/ChatContext';

const ChatPage = () => {
  return (
    <ChatProvider>
      <Layout>
        <div className="w-full h-full">
          <ChatInterface />
        </div>
      </Layout>
    </ChatProvider>
  );
};

export default ChatPage;